export const documentUploadQuery = `{
  documentUpload(id: "${process.env.REACT_APP_DOCUMENT_UPLOAD_ID}") { 
    title
    errorMessage
    successMessage
    successHeading
    submitButtonLabel
    privacyNotice
    nextButtonLabel
    emailSuccessIcon {
      fileName
      url
    }
    deleteIcon {
      fileName
      url 
    }
    backgroundLightGrey {
      fileName
      url
    }
    backgroundGrey {
      fileName
      url
    }
    circleRadioOn {
      fileName
      url
    }
    circleRadioOff {
      fileName
      url
    }
    circleRadioCompleted {
      fileName
      url
    }
    documentTypeNotice
    documentTypeHeading
    uploadButtonLabel
    uploadOptions {
      title 
      optionsCollection {
        items {
          label
          value
        }
      }
    }
  }
}
`

export function documentParser(CMSData) {
  if (CMSData == undefined) {
    return { error: "Internal error" }
  } else {
    return {
      ...CMSData.documentUpload,
    }
  }
}
